import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
function PersonalPage() {
    return (
        <section class="lk">
     <Container>
        <Row>
          <div class="col-lg-12">
            <div class="lk__wrapper">
              <div class="lk__info">
                <div class="lk-info__title">Личный кабинет</div>
                <div class="lk-info__content d-flex">
                  <div class="lk-info-content__main lk-content-main d-flex">
                    <div class="lk-content-main__avatar">
                      <div class="lk-avatar__img">
                        <img src="/img/lguser.svg" alt="user" />
                      </div>
                      <div class="lk-avatar__title">
                        <h2>
                          Изменить
                        </h2>
                      </div>
                    </div>
                    <div class="lk-content-main__info">
                      <div class="content-main-info__name">
                        Дмитрий
                      </div>
                      <div class="content-main-info__contacts d-flex">
                        <div class="main-info-contacts__mail">
                          <a href="#">
                            E-mail
                          </a>
                        </div>
                        <div class="main-info-contacts__mymail">
                          <a href="#">
                            redslon@mail.ru
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="lk-info-content__change">
                    <div class="lk-content-change__btn">
                      <a href="#">
                        ИЗМЕНИТЬ ДАННЫЕ И ПАРОЛЬ
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lk__pay lk-pay">
                <h2 class="lk-pay__title">
                  PRO Аккаунт
                </h2>
                <p class="lk-pay__subtitle">
                  Преимуществом PRO аккаунта является возможность поднимать
                  объявление вверх списка (под закрепленные объявления) один раз
                  в два дня.
                </p>
                <p class="lk-pay__subtitle">
                  Чтобы поднять объявление, перейдите на страницу “Мои
                  объявления” и напротив нужного нажмите на иконку поднятия.
                  Объявление поднимется на верхнюю позицию автоматически и будет
                  снижаться по мере добавления новых объявлений.
                </p>
                <div class="lk-box">
                  <div class="lk-pay__content d-flex">
                    <div class="dropdown">
                      <button class="search-item__vp2 vp1">
                        Права владельца
                        <div class="dropdown-child1 vpchild">
                          <a href="#">Подраздел 1</a>
                          <a href="#">Подраздел 2</a>
                          <a href="#">Подраздел 3</a>
                          <a href="#">Подраздел 4</a>
                          <a href="#">Подраздел 5</a>
                        </div>
                      </button>
                    </div>
                    <div class="dropdown__pay">
                      75$
                    </div>
                  </div>
                  <div class="icons__box d-flex">
                    <div class="lk-pay__icons d-flex">
                      <a href="#"><img src="/img/pay1.png" alt="icon" /></a>
                      <a href="#"><img src="/img/pay2.png" alt="icon" /></a>
                      <a href="#"><img src="/img/pay3.png" alt="icon" /></a>
                      <a href="#"><img src="/img/pay4.png" alt="icon" /></a>
                    </div>
                    <div class="lk-pay__btn">
                      <a href="#">
                        Купить
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lk__check">
                <div class="lk__check__items">
                  <div class="lk-chekc__item">
                    <div class="lk-check__title">
                      <h2>Настройка уведомлений</h2>
                    </div>
                    <form action="#" class="frolk d-flex">
                      <div class="form-box">
                        <input type="checkbox" id="lkcheck" checked />
                        <label for="lkcheck">Новые комментарии</label>
                        <input type="checkbox" id="lkcheck2" checked />
                        <label for="lkcheck2">Новые личные сообщения</label>
                        <input type="checkbox" id="lkcheck3" checked />
                        <label for="lkcheck3"
                          >Новый отзыв по безопасной сделке</label
                        >
                        <input type="checkbox" id="lkcheck4" />
                        <label for="lkcheck4">Новые сообщения о покупке</label>
                      </div>
                      <div class="form-box">
                        <input type="checkbox" id="lkcheck6" />
                        <label for="lkcheck6">Закрытие сделки</label>
                        <input type="checkbox" id="lkcheck7" />
                        <label for="lkcheck7"
                          >Уведомление об успешном платеже</label
                        >
                        <input type="checkbox" id="lkcheck8" />
                        <label for="lkcheck8">Решения арбитража</label>
                        <input type="checkbox" id="lkcheck9" />
                        <label for="lkcheck9"
                          >Изменение статуса безопасной сделки</label
                        >
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="lk__replies">
                <div class="lk-replies__title">
                  Отзывы по Безопасной сделке
                </div>
                <div class="lk-replies__btn">
                  <a href="#">У вас нет отзывов</a>
                </div>
              </div>
              <div class="lk__cash">
                <div class="lk-cash__title">
                  Мой кошелек
                </div>
                <div class="lk-cash__balance">БАЛАНС: <span>10$</span></div>
                <div class="lk-cash-btns d-flex">
                  <div class="lk-cash-btn">
                    <a href="#">ПОПОЛНИТЬ</a>
                  </div>
                  <div class="lk-cash-btn2">
                    <a href="#">ВЫВЕСТИ</a>
                  </div>
                </div>
                <div class="lk-cash__text">
                  Баланс RedSlon служит для оплаты сделок и покупки любых услуг.
                  Получайте деньги со сделок и покупайте другие группы без
                  комиссии. Пополняйте баланс напрямую и оплачивайте с него все
                  возможные услуги.
                </div>
              </div>
              <div class="lk__hist">
                <div class="lk-hist__title">
                  История
                </div>
                <div class="lk-hist___items d-flex">
                  <div class="lk-hist__item">
                    <div class="lk-hist-item__titles d-flex">
                      <div class="lk-hist-item__title lhit1">Сумма</div>
                      <div class="lk-hist-item__title">Кошелек</div>
                      <div class="lk-hist-item__title lhit3">Дата</div>
                    </div>
                    <div class="lk-hist-item__box d-flex">
                      <div class="hist__text">10$</div>
                      <div class="hist__text">Яндекс.Деньги</div>
                      <div class="hist__text">2020-07-01 в 21:41</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9 offset-lg-1 col-10 m-auto">
            <div class="price__items d-flex">
              <div class="price-item__count item-count">
                <div class="item-count__box">
                  <div class="item-count__subs">
                    Подписчики
                  </div>
                  <div class="mall-property">
                    <div
                      class="mall-slider-handles"
                      data-start="1"
                      data-end="1500"
                      data-min="1"
                      data-max="1500"
                      data-target="price"
                      style={{width:"100%"}}
                    ></div>

                    <input
                      data-min="price"
                      class="paso"
                      name="price-min"
                      value="1"
                    />
                    <input
                      data-max="price"
                      class="paso1"
                      name="price-max"
                      value="1500"
                    />
                  </div>
                </div>
              </div>
              <div class="price-item__count item-count">
                <div class="item-count__box">
                  <div class="item-count__subs">
                    Доход
                  </div>
                  <div class="mall-property">
                    <div
                      class="mall-slider-handles"
                      data-start="1"
                      data-end="5000"
                      data-min="5000"
                      data-max="5000"
                      data-target="price"
                      style={{width:"100%"}}
                    ></div>

                    <input
                      data-min="price"
                      class="paso"
                      name="price-min"
                      value="5000"
                    />
                    <input
                      data-max="price"
                      class="paso1 none"
                      name="price-max"
                      value="5000"
                    />
                    <div class="price__do">
                      До
                    </div>
                  </div>
                </div>
              </div>
              <div class="price-item__count item-count">
                <div class="item-count__box">
                  <div class="item-count__subs">
                    Цена
                  </div>
                  <div class="mall-property">
                    <div
                      class="mall-slider-handles"
                      data-start="1"
                      data-end="10"
                      data-min="10"
                      data-max="10"
                      data-target="price"
                      style={{width:"100%"}}
                    ></div>

                    <input
                      data-min="price"
                      class="paso"
                      id="paso"
                      name="price-min"
                      value="10"
                    />
                    <input
                      data-max="price"
                      class="paso1 none"
                      name="price-max"
                      value="1500"
                    />
                    <div class="price__do">
                      До
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="price__search d-flex">
              <div class="price-search__item search-item">
                <div class="search-item__title">
                  Тематика
                </div>

                <div class="dropdown">
                  <button class="search-item__vp1 tl">
                    Бизнес
                    <div class="dropdown-child">
                      <a href="#">Подраздел 1</a>
                      <a href="#">Подраздел 2</a>
                      <a href="#">Подраздел 3</a>
                      <a href="#">Подраздел 4</a>
                      <a href="#">Подраздел 5</a>
                    </div>
                  </button>
                </div>
              </div>
              <div class="price-search__item search-item">
                <div class="search-item__title">
                  Способ передачи
                </div>
                <div class="dropdown vp1">
                  <button class="search-item__vp1 vp1">
                    Права владельца
                    <div class="dropdown-child vpchild">
                      <a href="#">Подраздел 1</a>
                      <a href="#">Подраздел 2</a>
                      <a href="#">Подраздел 3</a>
                      <a href="#">Подраздел 4</a>
                      <a href="#">Подраздел 5</a>
                    </div>
                  </button>
                </div>
              </div>
              <div class="price-search__item search-item">
                <form action="#" class="price__form">
                  <input class="search-item3__search" placeholder="Поиск" />
                </form>
                <div class="search-item3__subf">
                  <a href="#" class="search-item3__subf_item"
                    >Сбросить фильтр</a
                  >
                </div>
              </div>
            </div>
            <div class="price-search__item search-item price-sort d-flex">
              <div class="price-sort__title">
                Сортировать
              </div>
              <div class="price-sort__items d-flex">
                <div class="price-sort__item">
                  По Актуальности
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
                <div class="price-sort__item">
                  По цене
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
                <div class="price-sort__item">
                  По Подписчикам
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
                <div class="price-sort__item">
                  По Доходу
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
              </div>
            </div>
            <div class="price-search__item search-item sm d-flex ml-auto">
              <div class="sm__item psi1">
                <a href="#"><i class="fas fa-globe"></i></a>
              </div>
              <div class="sm__item psi2">
                <a href="#"><i class="fab fa-tiktok"></i></a>
              </div>
              <div class="sm__item psi3">
                <a href="#"><i class="fab fa-youtube"></i></a>
              </div>
              <div class="sm__item psi4">
                <a href="#"><i class="fab fa-vk"></i></a>
              </div>
              <div class="sm__item psi5">
                <a href="#"><i class="fab fa-instagram"></i></a>
              </div>
              <div class="sm__item psi6">
                <a href="#"><i class="fab fa-facebook-f"></i> </a>
              </div>
              <div class="sm__item psi7">
                <a href="#"><i class="fab fa-odnoklassniki"></i></a>
              </div>
              <div class="sm__item psi8">
                <a href="#"><i class="fab fa-telegram-plane"></i></a>
              </div>
            </div>
          </div>
          </Row>
          </Container>
    </section>
    )
}

export default PersonalPage
